import * as React from 'react';
import {Modal} from "../../Modal";
import Button from "../../Button";
import './CreateEditBrandingModal.css';
import { IBranding } from '../../../infrastructure/interfaces'
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import { contentImagesRelativePath } from '../../../constants';

export interface CreateEditBrandingProps {
    show: boolean;
    onClose: any;
    branding?: IBranding;
    updateBranding(brandingID: number, brandingName: string, imageFormData?: FormData, imageFormDataWhite?: FormData): void;
    createBranding(brandingName: string, imageFormData: FormData, imageFormDataWhite: FormData): void;
}

export interface CreateEditBrandingState {
    //Form State
    imageFormData?: FormData;
    imageFormDataWhite?: FormData;
    brandingName: string;
    hasRequiredFields: boolean;
}

export default class CreateEditBrandingModal extends React.Component<CreateEditBrandingProps, CreateEditBrandingState> {

    constructor(props: any) {
        super(props);

        this.state = {
            imageFormData: undefined,
            imageFormDataWhite: undefined,
            brandingName: (props.branding) ? props.branding.title : '',
            hasRequiredFields: false,
        };
        this.onSave = this.onSave.bind(this);
    }

    componentWillReceiveProps(nextProps: any) {
        var newBrandingName = (nextProps.branding) ? nextProps.branding.title : '';
        this.setState({
            brandingName: newBrandingName,
            hasRequiredFields: newBrandingName.length > 0
        });
      }

    updateBranding = () => {
        
        if (this.props.branding && this.props.branding.id) {
            if (this.props.updateBranding) {
                this.props.updateBranding(this.props.branding.id,
                                          this.state.brandingName,
                                          this.state.imageFormData,
                                          this.state.imageFormDataWhite);
            }
        } else {
            if (!this.state.imageFormData || !this.state.imageFormDataWhite) {
                return;
            }
            this.props.createBranding(this.state.brandingName, 
                                      this.state.imageFormData,
                                      this.state.imageFormDataWhite);
        }
    }

    handleChangeBranding(selectorFiles: FileList | null)
    {
        if (selectorFiles != null) {
            for (var key in selectorFiles) {
                // check if this is a file. If so, add it and exit.
                if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {

                    var imageFormData = new FormData();
                    imageFormData.set(ImageFileTypes.PRODUCT_BRANDING, selectorFiles[key]);
                    this.setState({imageFormData},
                        () => this.hasValidFields());
                    break;
                }
            }
        }
    }

    handleChangeBrandingWhite(selectorFiles: FileList | null)
    {
        if (selectorFiles != null) {
            for (var key in selectorFiles) {
                // check if this is a file. If so, add it and exit.
                if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
                    var imageFormDataWhite = new FormData();
                    imageFormDataWhite.set(ImageFileTypes.PRODUCT_BRANDING_WHITE, selectorFiles[key]);
                    this.setState({imageFormDataWhite},
                        () => this.hasValidFields());
                    break;
                }
            }
        }
    }

    onSave() {
        this.updateBranding();
        this.props.onClose();        
    }

    handleInputGroupChange(newBrandingName: string) {
        this.setState({
            brandingName: newBrandingName
          }, () => this.hasValidFields());
    }

    hasValidFields() {

        const hasValidText = (this.state.brandingName.length > 1);
        const hasValidImages = (this.props.branding)
            ? true
            : ( 
                ((this.state.imageFormData != undefined)
                 && (this.state.imageFormData.get(ImageFileTypes.PRODUCT_BRANDING) != null))
                && 
                ((this.state.imageFormDataWhite != undefined)
                 && (this.state.imageFormDataWhite.get(ImageFileTypes.PRODUCT_BRANDING_WHITE) != null))
              )
        this.setState({ hasRequiredFields: (hasValidText && hasValidImages) });
    }

    closeModal() {
        this.setState({
            brandingName: '',
        });
        this.props.onClose();
    }

    render() {
        return (
            <Modal show={this.props.show}
                   onClose={() => {this.closeModal();}}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5>
                            {this.props.branding ? this.props.branding.title : 'Create Branding Image Set'}
                        </h5>
                        (SVG)
                    </Modal.Title>
                    <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>                        
                </Modal.Header>
                <Modal.Body>
                    <div className="brandingContainer">
                        <div className="brandingInputContainer">
                            <div>
                                <b>Branding Name:  </b>
                                <input
                                    placeholder="Branding Name"
                                    maxLength={100}
                                    value={this.state.brandingName}
                                    onChange={e => {
                                        this.handleInputGroupChange(e.target.value);
                                    } }/>
                            </div>
                        </div>

                        <div className="brandingInputContainer">
                            <label>
                                <b>Full Color Image</b>
                            </label>
                            {
                                (this.props.branding)
                                    ? <div className="brandingImageContainer"><img className="editImageModalImage" src={contentImagesRelativePath + this.props.branding.image} /></div>
                                    : <div></div>
                            }
                            <input type="file" className="filepond" onChange={(e) => this.handleChangeBranding(e.target.files)} />
                        </div>
                        
                        <div className="brandingInputContainer">
                            <label>
                                <b>White Image</b>
                            </label>
                            {
                                (this.props.branding)
                                    ? <div className="brandingImageContainer"><img className="editImageModalImage" src={contentImagesRelativePath + this.props.branding.coverImage} /></div>
                                    : <div></div>
                            }
                            <input type="file" className="filepond" onChange={(e) => this.handleChangeBrandingWhite(e.target.files)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                        Cancel
                    </Button>
                    <Button
                        bsClass="primary"
                        disabled={!this.state.hasRequiredFields}
                        onClick={() => {
                            this.onSave();
                        }}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Modals/CreateEditBrandingModal/CreateEditBrandingModal.tsx